import { useNavigate } from "react-router-dom";
import _ from "lodash";
import { Image } from "react-bootstrap";

import styles from "./styles.module.scss";
import cx from 'classnames';

export function SmallTalkNotification({ message, handleClose }) {
  const navigate = useNavigate();

  const url = `/engage/${_.get(message, 'sender.chatUser', '')}`;

  return (
      <div className={styles.link} onClick={() => navigate(url)}>
        <div className={styles.notification}>
          <div className={styles.header}>
            <div className={styles.avatar}>
              {_.get(message, 'sender.icon', '') && <Image className={styles.avatarImage} roundedCircle src={_.get(message, 'sender.icon', '')} alt="avatar" />}
              {!_.get(message, 'sender.icon', '') && <div className={styles.avatarInitials}>{_.get(message, 'sender.name', '').charAt(0)}</div>}
            </div>
            <div className={styles.contact}>
              {_.get(message, 'sender.name', ).replace("null", "")}
            </div>
            <div className={styles.closeIconContainer} onClick={(e) => {
              e.stopPropagation();
              handleClose()}}>
              <i className={cx("paperflite-close", styles.closeIcon)} />
            </div>
          </div>
          <div className={styles.text}>{message.text}</div>
          </div>
        </div>
  );
}